import {useNavigate, useParams} from "react-router-dom";
import CommonClass from "@/utils/common.ts";
import CMS from "@/utils/cms.ts";
import {LocalLanguage} from "@/types_and_interfaces/types.ts";
import {useTranslation} from "react-i18next";
import DashboardWideComponent from "@/components/DashboardWideComponent.tsx";
import st from  "@/styles/OfficePage.module.scss"
import OfficeCard from "@/ui/OfficeCard.tsx";
import {useEffect, useRef} from "react";
import MapLayout from "@/components/MapLayout.tsx";
import {MarkerF, OverlayView} from "@react-google-maps/api";
import Images from "@/utils/images.ts";
import DashboardClass from "@/utils/dashboard_class.ts";
import LoadMapScript from "@/components/LoadMapScript.tsx";

const OfficePage = () => {
    
    const {location} = useParams()
    const offices:any = CMS.offices
    const { i18n} = useTranslation()
    const navigate = useNavigate()

    
    const getOffice = () => {
        if(Array.isArray(offices.offices) && offices.offices.length) {
            return offices.offices.find((obj:any) => CommonClass.convertLocationToId(obj.coordonates) === location)
        }
        
        return {}
    }
    
    const office = getOffice() && CMS.langAwareFilter(getOffice(), (i18n.language as LocalLanguage))
    
    
    const resizeHandler = () => {
        if(window.innerWidth >= 1050) {
            navigate(DashboardClass.dashboard_routes.Locations)
        }
    }
    
    useEffect(() => {
        
        resizeHandler()
        
        window.addEventListener("resize", resizeHandler)
        
        return () => {
            window.removeEventListener("resize", resizeHandler)
            
        }
    }, []);
    
    
    return Object.keys(office).length ? (
        
        <DashboardWideComponent
            
            backUrl={DashboardClass.dashboard_routes.Locations}
            
            heading={office?.city_name}
            
            column_center={
                <div className={st.column_center}>
                    
                    <OfficeCard className={st.office} office={office} />

                    <MapContainer office={office} />
                    
                </div>
            }
        />
        
    ) : null
}


interface MapProps {
    office: any
}

const MapContainer:React.FC<MapProps> = ({office}) => {
    
    const ref = useRef<any>(null)
    
    
    useEffect(() => {
        
        if(ref.current && window !== undefined) {
            let elem = ref.current
            
            let h = window.innerHeight
            let elem_y = elem.getBoundingClientRect()?.y
            let elem_h_to_set = h - elem_y
            
            elem.style.height = `${elem_h_to_set}px`
        }
        
    }, []);
    
    return (
        <div ref={ref} className={st.map_container}>
            {/*{(window.google && window.google.maps) ? (*/}
            {/*    */}
            {/*    <MapLayout center_setted={CommonClass.convertCoordinatesToLatLng(office.coordonates)} mapStyle={{height: "100%"}}>*/}
            {/*        <OverlayView*/}
            {/*            position={CommonClass.convertCoordinatesToLatLng(office.coordonates)}*/}
            {/*            mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}*/}
            {/*        >*/}
            {/*            <MarkerF*/}
            {/*                position={CommonClass.convertCoordinatesToLatLng(office.coordonates)}*/}
            {/*                icon={{*/}
            {/*                    url: Images.map.MarkerSelected,*/}
            {/*                }}*/}
            {/*            />*/}
            {/*        </OverlayView>*/}
            {/*    </MapLayout>*/}
            {/*    */}
            {/*) : (*/}
            {/*    */}
                <LoadMapScript>
                    <MapLayout center_setted={CommonClass.convertCoordinatesToLatLng(office.coordonates)} mapStyle={{height: "100%"}}>
                        <OverlayView
                            position={CommonClass.convertCoordinatesToLatLng(office.coordonates)}
                            mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                        >
                            <MarkerF
                                position={CommonClass.convertCoordinatesToLatLng(office.coordonates)}
                                icon={{
                                    url: Images.map.MarkerSelected,
                                }}
                            />
                        </OverlayView>
                    </MapLayout>
                </LoadMapScript>
            {/*    */}
            {/*    */}
            {/*)}*/}
        </div>
    )
}


export default OfficePage